/**
 * homePathForRole — destino de navegación post-autenticación según rol.
 *
 * Centraliza la lógica de redirect post-login/MFA para no repetirla en
 * MfaVerify, MfaSetup y cualquier otro punto de entrada autenticado.
 *
 * ADR-038: super_admin entra directamente a /platform/tenants; el resto
 * al tenant dashboard (/clients por default, que ya era el comportamiento previo).
 */
import type { AuthUser } from '../api/auth.js';

export function homePathForRole(role: AuthUser['role'] | undefined): string {
  if (role === 'super_admin') return '/platform/tenants';
  return '/clients';
}
